var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 619.55 457.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b86b2b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.53,149.38S91.36,148.43,29.06,381.53c0,0-60.29-280.89,252.71-301.89,0,0,410.58-222.92,300.29,303C582.06,382.68,507.3,203.12,304.53,149.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.28,304.94,70.6,340.41A6.75,6.75,0,0,0,83,336.8l1.41-97.93a5.06,5.06,0,0,0-9.69-2.11L46.87,300.12A5,5,0,0,0,47.28,304.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.56,276.8l-8.47,88.05a5.06,5.06,0,0,0,8.75,3.92l38.58-41.68a5,5,0,0,0,1.35-3.42l.14-46.37a5,5,0,0,0-5-5.07H525.59A5.06,5.06,0,0,0,520.56,276.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.3,267l15.9,9.28a5.34,5.34,0,0,0,7.76-2.82L119.39,223a5.32,5.32,0,0,1,6.91-3.21l34.56,12.69a5.29,5.29,0,0,0,7-3.69l8.36-38.55a5.34,5.34,0,0,1,8.67-2.74l63.79,55a5.32,5.32,0,0,0,8.72-3l10.71-66c.86-5.27,8.51-5.85,10.22-.78l6,17.88c1.63,4.86,8.89,4.6,10.13-.37l5-20.14c1.29-5.18,9-5.16,10.24,0l14,57.26c1.08,4.44,7.25,5.34,9.66,1.41l26.84-43.85c2.62-4.27,9.41-2.75,9.79,2.2l3.71,48c.33,4.39,5.95,6.3,9.09,3.08l33.19-34a5.36,5.36,0,0,1,8.84,1.88l8.51,24.75a5.35,5.35,0,0,0,9.57.92h0c2.58-4.35,9.47-2.84,9.83,2.16l2.69,37.43c.34,4.71,6.62,6.44,9.51,2.62l8.05-10.63c3.31-4.36,10.48-1.38,9.43,3.92l-5.35,27.1a5.19,5.19,0,0,0,6.76,5.77l42.65-13a5.22,5.22,0,0,0,3-2.39l35.5-62.34a4.93,4.93,0,0,0-1.37-6.41L387.9,83.7a5.44,5.44,0,0,0-4.42-1L250.87,111.93a4.92,4.92,0,0,0-.85.26L128.82,160.9a5.2,5.2,0,0,0-2.71,2.47L77.29,260.49A5,5,0,0,0,79.3,267Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.87,138.89s1.9-242.7,247.12-86.45L261,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,241.67S4.36,79.53,154.56,114.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.06,381.53s-68.63-120.63,5-180.26l18.5,12.61L34,285.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.84,258.38s54.51,63.34-17.78,124.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.87,379.3,560.4,442.48c-4.32,10.73-20.3,7.47-20.07-4.1l2.13-106.94a10.5,10.5,0,0,1,1.44-5.09l21.29-36.1A10.42,10.42,0,0,1,582,288.7l13.6,15.63A10.41,10.41,0,0,1,598,313L585.87,379.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.54,388l26.71,62.66c4.53,10.64,20.44,7.06,20-4.5L74,339.29a10.44,10.44,0,0,0-1.54-5.06l-22-35.67a10.41,10.41,0,0,0-16.85-1.21L20.3,313.24A10.42,10.42,0,0,0,18.09,322l13.45,66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset18);
export default __webpack_public_path__ + "static/media/Asset 18.836a4cbd.svg";
export { ForwardRef as ReactComponent };